export default __webpack_public_path__ + "static/media/aboutus.54ec9fb5.mp4";